//Library
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import Swal from 'sweetalert2';
import ReactLoading from 'react-loading';
import { pushUserIdToDataLayer } from '../../utils/analytics.js';
 
//redux
import { connect } from 'react-redux';
import { purchaseInit, stepComplete, getPDF, checkKyc, setSelectData, cleanCombinItem } from '../../action/anueInfoAction';
//Component
import Step0 from './Step0';
import Step1 from './Step1';
import Step2 from './Step2';
import Step2BySec from './Step2BySec';
class Purchase extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 0,
            //投資人須知 公開說明書 通路報酬
            pdfPath: [],
            //組合ID
            gid: "",
            //組合名稱
            gdName: "",
            //風險等級名稱
            context: "",
            //選擇的基金資料
            fundList: [],
            //可使用的交易幣別
            allowAcc: [],
            marketingList: [],
            combinList: [],
            //顯示Loading
            isLoading: false,
        }
        this.child = React.createRef();
    }

    /********************************************************************
                            步驟一  選擇投組
    ********************************************************************/

    componentWillMount() {
        if (this.props.isLogin === "N") {
            this.props.history.push("/Login");
        } else {
            
            if (this.props.prevFundList === undefined && this.props.allFundList === undefined) {
                this.setState({ isLoading: true });
                this.props.purchaseInit((response) => {
                    if (response.data.allFundList !== null && Object.keys(response.data.allFundList).length !== 0) {
                        let { combinList } = response.data.allFundList;
                        this.setState({ combinList: combinList, isLoading: false }, () => {
                            if (this.props.combinItem !== undefined && this.checkAcctCanBuy(this.props.combinItem["allowAcc"])) {
                                let { gid, gdName, context, marketingList } = this.props.combinItem;
                                this.props.cleanCombinItem();
                                this.goStep1(gid, gdName, context, marketingList, this.props.combinItem["allowAcc"]);
                            } else if (this.props.combinItem !== undefined) {
                                return;
                            }
                        });
                    }
                });
            } else {
                if (this.props.allFundList !== null && Object.keys(this.props.allFundList).length !== 0) {
                    let { combinList } = this.props.allFundList;
                    this.setState({ combinList: combinList }, () => {
                        if (this.props.combinItem !== undefined && this.checkAcctCanBuy(this.props.combinItem["allowAcc"])) {
                            let { gid, gdName, context, marketingList } = this.props.combinItem;
                            this.props.cleanCombinItem();
                            this.goStep1(gid, gdName, context, marketingList, this.props.combinItem["allowAcc"]);
                        } else if (this.props.combinItem !== undefined) {
                            return;
                        }
                    });
                }
            }

            pushUserIdToDataLayer();  //登入
        }
    }

    getPDFHandler(fundList) {
        let data = [];
        for (let i = 0; i <= fundList.length - 1; i++) {
            data.push(fundList[i].fundID);
        }
        this.props.getPDF(data);
        this.props.checkKyc(data);
    }

    backStep0() {
        this.setState({ step: 0 });
    }

    goStep1(gid, gdName, context, marketingList, allowAcc) {
        if (this.checkAcctCanBuy(allowAcc)) {
            this.setState({ step: 1, gid, gdName, context, marketingList, allowAcc });
        }
    }

    goStep2(fundList) {
        this.getPDFHandler(fundList);
        this.setState({ fundList: fundList, step: 2 });
    }

    checkAcctCanBuy(allowAcc) {
        if (this.props.acctT !== undefined && this.props.acctF !== undefined) return true;
        if (this.props.acctT !== undefined && allowAcc.join().indexOf("T") !== -1) return true;
        if (this.props.acctF !== undefined && allowAcc.join().indexOf("F") !== -1) return true;
        Swal.fire("該投組包含新台幣計價基金，您需有核印完成之新台幣扣款帳號才能申購");
        return false
    }


    /********************************************************************
                            步驟二  選擇帳戶金額
    ********************************************************************/

    purchaseComplete(completeData, selAcct, invDayData, promText) {

        completeData.gid = this.state.gid;
        completeData.fundList = this.state.fundList;
        this.props.stepComplete(completeData, () => {
            this.props.setSelectData({
                selectGdName: this.state.gdName,
                selectAccount: selAcct,
                selectContext: this.state.context,
                selectInvDay: invDayData,
                selectPromText: promText,
            });
            if (window.group_Done_Appier !== undefined) {
                try {
                    let product_group_id = "";
                    let product_group_name = this.state.gdName;
                    let product_group_amount = completeData.altAmount
                    let product_group_TrRSPamount = completeData.rspAmount
                    let product_group_fund = completeData.fundList.map((value) => { return value.fundID }).join();
                    let purchase_eventcode = "";
                    let purchase_bonus_point = 0;
                    let purchase_bonus_campaign = completeData.promText;
                    window.group_Done_Appier(product_group_id, product_group_name, product_group_amount, product_group_TrRSPamount, product_group_fund, purchase_eventcode, purchase_bonus_point, purchase_bonus_campaign)
                } catch (e) { }
            }

            this.props.history.push("/PurchaseComplete");
        })
    }


    render() {
        return <div style={{ overflowX: "hidden" }}>
            {
                this.state.isLoading === true ?
                    <div style={{ width: "100%", height: "100%", position: "absolute", textAlign: "center", paddingTop: "25%", zIndex: "10", backgroundColor: "black", opacity: "0.5" }}>
                        <ReactLoading type={"spin"} style={{ margin: "auto", fill: "white", height: "15%", width: "5%" }} />
                    </div> : ""
            }
            {
                this.props.chkIsFirst === "N" ?
                    <Step2BySec
                        context={this.state.context}
                        gdName={this.state.gdName}
                        gid={this.state.gid}
                        mktFunds={this.state.fundList}
                        purchaseComplete={(completeData, selAcct, invDay, promText) => { this.purchaseComplete(completeData, selAcct, invDay, promText) }} /> :
                    this.state.step === 0 ?
                        <Step0
                            combinList={this.state.combinList}
                            goStep1={(gid, gdName, context, marketingList, allowAcc) => { this.goStep1(gid, gdName, context, marketingList, allowAcc) }} /> :
                        this.state.step === 1 && this.props.chkIsFirst === "Y" ?
                            <Step1
                                backStep0={() => { this.backStep0() }}
                                marketingList={this.state.marketingList}
                                goStep2={(fundList) => { this.goStep2(fundList) }}
                                gdName={this.state.gdName}
                                context={this.state.context} /> :
                            this.state.step === 2 && this.props.chkIsFirst === "Y" ?
                                <Step2
                                    gdName={this.state.gdName}
                                    context={this.state.context}
                                    fundList={this.state.fundList}
                                    gid={this.state.gid}
                                    allowAcc={this.state.allowAcc}
                                    purchaseComplete={(completeData, selAcct, invDayData, promText) => { this.purchaseComplete(completeData, selAcct, invDayData, promText) }}
                                    backStep0={() => { this.backStep0() }} /> : ""
            }
        </div >;
    }
}
function mapStateToProps(state) {
    return {
        isLogin: state.anueInfoState.isLogin,
        allFundList: state.anueInfoState.allFundList,
        prevFundList: state.anueInfoState.prevFundList,
        chkIsFirst: state.anueInfoState.chkIsFirst,
        selectPDF: state.anueInfoState.selectPDF,
        combinItem: state.anueInfoState.combinItem,
        acctT: state.anueInfoState.acctT,
        acctF: state.anueInfoState.acctF
    };
}

export default connect(mapStateToProps, { purchaseInit, stepComplete, getPDF, checkKyc, setSelectData, cleanCombinItem })(withRouter(Purchase));